import React from 'react';

const LoginHeader = () => {
  return (
    <div className="mb-8">
      {/* Logo and company name */}
      <div className="flex items-center gap-3 mb-4">
        <div 
          className="w-12 h-12 rounded-lg flex items-center justify-center text-white text-xl font-bold"
          style={{ backgroundColor: '#0095fa' }}
        >
          SH
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-800" style={{ fontFamily: 'Montserrat' }}>
            Samah
          </h1>
          <p className="text-sm text-gray-600" style={{ fontFamily: 'Montserrat' }}>
            Home Care
          </p>
        </div>
      </div>

      {/* Welcome text */}
      <h2 className="text-3xl font-bold text-gray-800 mb-2" style={{ fontFamily: 'Montserrat' }}>
        Welcome Back
      </h2>
      <p className="text-gray-600" style={{ fontFamily: 'Montserrat' }}>
        Login to your account to continue
      </p>
    </div>
  );
};

export default LoginHeader;